<template>
  <div class="d-flex flex-column" style="min-height: 100vh">
    <!-- TABS -->
    <v-tabs
      :elevation="10"
      style="width: 100%"
      center-active
      fixed-tabs
    >
      <v-tab
        v-for="(item, index) in menuItems"
        :key="index"
        :disabled="item.disabled"
        :to="item.link"
      >
        <v-icon v-if="item.icon" class="mr-2">{{ item.icon }}</v-icon>
        {{ item.title }}
      </v-tab>
    </v-tabs>

    <!-- MAIN LAYOUT -->
    <div style="display: flex;">
      <SideBar
        :isMini="isMiniMenu"
        @update:isMini="isMiniMenu = $event"
      />
      <div style="flex: 1; overflow-y: auto; width: 100%;">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '../components/curves/SideBar.vue'

export default {
  components: {
    SideBar,
  },
  data () {
    return {
      menuItems: [
        // { title: this.$t('menus.vertices'), icon: 'mdi-chart-line', link: '/grid/data/vertices'},
        // { title: this.$t('menus.curves'), icon: 'mdi-chart-bell-curve', link: '/grid/data/curves'},
        { title: this.$t('menus.pricer'), icon: 'mdi-chart', link: '/grid/data/pricer'},
        { title: this.$t('menus.forwardCurves'), icon: 'mdi-chart', link: '/grid/data/forward-curves'},
        { title: this.$t('menus.marketData'), icon: 'mdi-chart', link: '/grid/data/market-data'},
      ],
      isMiniMenu: true
    }
  },
}
</script>

<style scoped>
</style>